import type {AlertProps as MantineAlertProps} from '@mantine/core';
import {Alert as MantineAlert} from '@mantine/core';

export type AlertProps = MantineAlertProps;

/**
 * Inline alert callout — design-layer pass-through over Mantine `Alert`.
 * @registry Pass-through Mantine Alert; import this instead of @mantine/core outside src/design.
 */
export const Alert = MantineAlert;
